import React  from 'react';
import { AlertProps, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useNotification } from '../../+state/useNotification';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={12} ref={ref} variant="filled" {...props} />;
});

export const DEFAULT_DISMISS_TIME = 5000;

export const Toast = () => {
  const { open, dismissTime, severity, message, closeToast } = useNotification();
  return (
    <Snackbar open={open} autoHideDuration={dismissTime} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              onClose={closeToast}>
      <Alert onClose={closeToast} severity={severity} sx={{ maxWidth: { mobile: 200, laptop: 600 } }}>
        {message}
      </Alert>
    </Snackbar>
  );
};